
            const data = {"name":"ic_moon","data":{"width":"18","height":"18","viewBox":"0 0 18 18","data":"<path pid=\"0\" d=\"M9 15.75a6.75 6.75 0 0 0 6.748-6.939A5.25 5.25 0 0 1 7.97 2.329 6.75 6.75 0 0 0 9 15.75Z\" _stroke=\"#8B8ABB\" stroke-width=\"1.125\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#8B8ABB"}],"stopColors":[]}}
        
                    module.exports = data
                    